module.exports = __webpack_public_path__ + "img/BI.d3f4ce61.jpg";